/* eslint-disable react-hooks/exhaustive-deps */

import { withProtectedRoute } from "../../../utils/HOC/withProtectedRoute";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";
import { UsersTable } from "./UsersTable";
import { useTomraDrops } from "../../../store/useTomraDrops";
import { useStatiegeldProducts } from "../../../store/useStatiegeldProducts";
import { ReactComponent as LeftArrow } from "../../../assets/icons/arrows/left-arrow.svg";

function ProductUsersListScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const params = useParams();
  const { usersWithBarcodeDrops, getUsersWithBarcodeDrops } = useTomraDrops();
  const { getStatiegeldProducts, statiegeldProducts } = useStatiegeldProducts();

  /** Effects */
  useEffect(() => {
    getUsersWithBarcodeDrops(params?.id as any);
  }, []);

  useEffect(() => {
    if (!statiegeldProducts?.length) {
      getStatiegeldProducts();
    }
  }, [statiegeldProducts]);

  /** Callbacks */
  const goBack = () => navigate(-1);
  const productName =
    statiegeldProducts?.find((product) => product?.gtin === params?.id)?.name ??
    "Unknown";

  return (
    <div>
      <div className="flex w-full justify-between">
        <div className="flex flex-row items-center justify-start mb-11">
          <LeftArrow onClick={goBack} className="mr-3 cursor-pointer" />
          <h1 className="font-satoshi text-sm sm:text-2xl font-bold text-dark">
            Users list that dropped {params?.type}: [{params?.id} -{" "}
            {productName}]
          </h1>
        </div>
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!usersWithBarcodeDrops?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no user created yet.
          </p>
        ) : (
          <UsersTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(ProductUsersListScreen);
